class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.variantChangeHandler = this.variantChangeHandler.bind(this);
    this.sellingPlanChangeHandler = this.sellingPlanChangeHandler.bind(this);
  }

  connectedCallback() {
    const variantInput = document.querySelector('.product-variant-id');
    if (variantInput) {
      variantInput.addEventListener('change', this.variantChangeHandler);
    }

    this.querySelectorAll('input[name="selling_plan"]').forEach(radio => {
      radio.addEventListener('change', this.sellingPlanChangeHandler);
    });

    this.updateBenefitsVisibility();
    this.syncPriceToMain();
  }

  disconnectedCallback() {
    const variantInput = document.querySelector('.product-variant-id');
    if (variantInput) {
      variantInput.removeEventListener('change', this.variantChangeHandler);
    }

    this.querySelectorAll('input[name="selling_plan"]').forEach(radio => {
      radio.removeEventListener('change', this.sellingPlanChangeHandler);
    });
  }

  sellingPlanChangeHandler() {
    this.updateBenefitsVisibility();
    this.syncPriceToMain();
  }

  // ✅ Subscribe selected → uski price main price element mein daalo
  // ✅ One-time selected → original variant price wapas daalo
  syncPriceToMain() {
    const mainPriceEl = document.querySelector('.price-item.price-item--sale.price-item--last');
    if (!mainPriceEl) return;

    const oneTimeRadio = this.querySelector('input[name="selling_plan"][value=""]');
    const isOneTimeSelected = oneTimeRadio && oneTimeRadio.checked;

    if (isOneTimeSelected) {
      // One-time ki apni price
      const oneTimePrice = this.querySelector('.esa__one-time-box .esa__sale_price');
      if (oneTimePrice) {
        mainPriceEl.textContent = oneTimePrice.textContent.trim();
      }
    } else {
      // Subscribe ki price
      const subPrice = this.querySelector('.esa__subscription-box .esa__sale_price');
      if (subPrice) {
        mainPriceEl.textContent = subPrice.textContent.trim();
      }
    }
  }

  updateBenefitsVisibility() {
    const benefits = this.querySelector('.esa__subscription-benefits');
    if (!benefits) return;

    const oneTimeRadio = this.querySelector('input[name="selling_plan"][value=""]');
    const isOneTimeSelected = oneTimeRadio && oneTimeRadio.checked;

    if (isOneTimeSelected) {
      benefits.classList.remove('esa--open');
    } else {
      benefits.classList.add('esa--open');
    }
  }

variantChangeHandler(e) {
  fetch(`${this.dataset.productUrl}?variant=${e.target.value}&section_id=${this.dataset.sectionId}`)
    .then(r => r.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const newWidget = doc.querySelector('.esa__subscription-container');

      if (newWidget) {
        this.style.display = 'block';

        this.querySelectorAll('input[name="selling_plan"]').forEach(el => {
          el.disabled = false;
        });

        const subscription_container = this.querySelector('.esa__subscription-container');
        if (subscription_container) {
          this.querySelector('.esa__save-badge').textContent = newWidget.querySelector('.esa__save-badge').textContent;
          this.querySelector('.esa__subscription-box .esa__price').innerHTML = newWidget.querySelector('.esa__subscription-box .esa__price').innerHTML;
          this.querySelector('.esa__one-time-box .esa__price').innerHTML = newWidget.querySelector('.esa__one-time-box .esa__price').innerHTML;
          this.querySelector('.esa__subscription-benefits').innerHTML = newWidget.querySelector('.esa__subscription-benefits').innerHTML;
        } else {
          this.innerHTML = doc.querySelector('#esa__subscription-widget').innerHTML;
        }

        this.querySelectorAll('input[name="selling_plan"]').forEach(radio => {
          radio.addEventListener('change', this.sellingPlanChangeHandler);
        });

        this.updateBenefitsVisibility();

        // ✅ Shopify apni price update kare uske baad hamara sync chale
        this.waitForPriceUpdateThenSync();

      } else {
        this.style.display = 'none';
        this.querySelectorAll('input[name="selling_plan"]').forEach(el => {
          el.disabled = true;
        });
      }
    });
}

waitForPriceUpdateThenSync() {
  const mainPriceEl = document.querySelector('.price-item.price-item--sale.price-item--last');
  if (!mainPriceEl) return;

  // Shopify jo price set kare usse capture karo
  const observer = new MutationObserver(() => {
    observer.disconnect(); // sirf ek baar fire karo
    // Ab Shopify ki update ho gayi, hamara sync chalao
    setTimeout(() => this.syncPriceToMain(), 0);
  });

  observer.observe(mainPriceEl, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // Agar Shopify 1 second mein update na kare toh bhi sync karo
  setTimeout(() => {
    observer.disconnect();
    this.syncPriceToMain();
  }, 1000);
}
}

customElements.define('subscription-widget', SubscriptionWidget);